module.exports = __webpack_public_path__ + "static/voting-7daff06c7d0d7ac4d1bd06b1307224b3.png";